<form
  *ngIf="consultationForm"
  [formGroup]="consultationForm"
  (ngSubmit)="consultationDialogSubmit()"
>
  <div
    class="p-field required-field"
    [ngClass]="{
      'p-invalid':
        consultationForm.get('title')?.invalid &&
        (consultationForm.get('title')?.touched ||
          consultationForm.get('title')?.dirty)
    }"
  >
    <label for="title">Titel*</label>
    <p-floatLabel>
      <input pInputText id="title" type="text" formControlName="title" />
    </p-floatLabel>
  </div>

  <div class="form-group" *ngIf="!selectedUser">
    <label>Kurs</label>
    <p-floatLabel variant="in">
      <p-dropdown
        [options]="availableCourses"
        name="courseId"
        [loading]="coursesLoading"
        optionLabel="courseName"
        optionValue="courseId"
        [showClear]="true"
        (onChange)="onCourseSelected($event.value)"
        formControlName="courseId"
        [filter]="true"
        filterBy="courseName"
      >
      </p-dropdown>
    </p-floatLabel>
  </div>

  <div class="form-group" *ngIf="!selectedUser">
    <label>
      {{
        consultationForm.get("courseId")?.value === -1
          ? "Interessent:in*"
          : "Teilnehmer:innen*"
      }}
    </label>

    <p-multiSelect
      formControlName="participantId"
      [options]="availableParticipants"
      optionLabel="fullName"
      optionValue="userId"
      display="chip"
      [filter]="true"
      [showToggleAll]="true"
      [virtualScroll]="true"
      styleClass="custom-scroll"
      [style]="{ width: '100%' }"
      [virtualScrollItemSize]="40"
      [disabled]="disableParticipantSelect"
      [ngClass]="{
        'ng-invalid ng-dirty':
          consultationForm.get('participantId')?.invalid &&
          (consultationForm.get('participantId')?.touched ||
            consultationForm.get('participantId')?.dirty)
      }"
    ></p-multiSelect>

    <p
      *ngIf="
        consultationForm.get('courseId')?.value &&
        availableParticipants.length === 0
      "
      style="margin-top: 5px; color: red; font-style: italic"
    >
      {{
        consultationForm.get("courseId")?.value === -1
          ? "Keine Interessent:innen gefunden."
          : "Keine Teilnehmer für diesen Kurs gefunden."
      }}
    </p>
  </div>

  <div class="form-group">
    <label>Bemerkungen</label>
    <p-editor formControlName="remarks" />
  </div>

  <!-- #region FILE DROP COMPONENT -->

  <app-filedrop
    bucketname="consultations"
    [oldFiles]="oldFiles"
    (fileUploadStarted)="onFileUploadStarted()"
    (fileUploadCompleted)="onFilesUploaded($event)"
  >
  </app-filedrop>

  <div>
    <p>(* Pflichtfelder)</p>
  </div>

  <!-- #endregion -->

  <div class="form-buttons">
    <button
      pButton
      [loading]="isSubmitting"
      label=""
      title="Speichern"
      icon="pi pi-save"
      type="submit"
      class="p-button-success"
      [disabled]="!consultationForm.valid || isSubmitting"
    ></button>
    <button
      pButton
      [loading]="isSubmitting"
      title="Abbrechen"
      type="button"
      label="Abbrechen"
      class="p-button-secondary"
      icon="pi pi-times"
      (click)="closeDialog()"
    ></button>
  </div>
</form>
